import { chartState } from "./state";
import { getStoreAccessors } from "typesafe-vuex";
import { State } from "../state";
export const getters = {
  echartOptions: (state: chartState) => {
    return state.echartOptions.data;
  },
};

const { read } = getStoreAccessors<chartState, State>("");

export const readEchartOptions = read(getters.echartOptions);
